import clsx from "clsx";
import type { FC } from "react";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { ClickEvent, Menu, MenuItem } from "mds/components/Menu";
import { ChevronDownIcon } from "mds/icons";

export type CourseViewOption = "course_code" | "term";

export type CourseViewOptionMenuProps = {
  selectedOption: CourseViewOption;
  onOptionChange: (option: CourseViewOption) => void;
  eventPrefix?: string;
};

const OPTIONS: { value: CourseViewOption; label: string }[] = [
  { value: "course_code", label: t("glossary.course_code") },
  { value: "term", label: t("glossary.term") },
];

export const CourseViewOptionMenu: FC<CourseViewOptionMenuProps> = ({
  selectedOption,
  onOptionChange,
  eventPrefix = "",
}) => {
  const selectedOptionData = OPTIONS.find((opt) => opt.value === selectedOption);

  const onItemClick = (e: ClickEvent) => {
    const newOption = e.value as CourseViewOption;
    onOptionChange(newOption);
  };

  const menuButton = (
    <Button
      className="flex w-[206px] items-center justify-between gap-1 text-black-tint-20"
      kind="white"
      size="s"
    >
      {selectedOptionData?.value === "course_code"
        ? t("home.view_by_course_code")
        : t("home.view_by_term")}
      <ChevronDownIcon />
    </Button>
  );

  return (
    <Menu direction="bottom" menuButton={menuButton} position="initial">
      {OPTIONS.map((option) => {
        const selected = selectedOption === option.value;
        return (
          <MenuItem
            checked={selected}
            className={clsx({ selected, "text-white": selected }, "center dropdown-item w-[208px]")}
            eventName={`${eventPrefix}Course view option selected`}
            eventProps={{ fieldValue: option.value }}
            key={option.value}
            value={option.value}
            onClick={onItemClick}
          >
            {option.label}
          </MenuItem>
        );
      })}
    </Menu>
  );
};
